import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
    },
    container: {
        maxHeight: '80vh'
    },
    firstSceneContainer: {
        display: 'flex',
        flexDirection: "column",
        justifyContent: 'center',
        alignItems: 'center',
        textAlign: 'center',
    },
    scoreSummaryRow: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center'
    },
    horizontalSpacedContainer: {
        marginLeft: 5,
        marginRight: 5,
    },
    redBox: {
        backgroundColor: "red",
        height: 30,
        width: 40,
        marginLeft: 5,
        marginRight: 5,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        fontSize: 14,
        fontWeight: "bold",
        border: "solid black 1px",
        borderRadius: 20,
        boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px"
    },
    blueBox: {
        backgroundColor: "blue",
        height: 30,
        width: 40,
        marginLeft: 5,
        marginRight: 5,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        fontSize: 14,
        fontWeight: "bold",
        border: "solid black 1px",
        borderRadius: 20,
        boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px"
    },
    athletePositionBoxContainer: {
        display: 'flex',
        flexDirection: "row",
        alignItems: 'center'
    },
    numberOfChallengedDecisions: {
        color: theme.palette.text.secondary,
        fontWeight: "bold",
        fontSize: 20
    },
}));

export {useStyles};